import { isNil } from 'lodash';
import { ReactNode, useCallback } from 'react';
import { ButtonView, View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { Colors, bounceIn } from '@shared/styles';

interface Props {
  checked: boolean;
  children?: ReactNode;
  onChange?: (newValue: boolean) => void;
}

export function Checkbox({ checked, children, onChange }: Props) {
  const handleChange = useCallback(() => {
    onChange?.(!checked);
  }, [checked, onChange]);

  const checkboxIcon = checked ? 'check-box' : 'check-box-empty';

  return (
    <View row>
      <ButtonView
        row
        key={String(checked)}
        role="checkbox"
        aria-checked={checked}
        disabled={isNil(onChange)}
        onClick={handleChange}
        className={checked && bounceIn}
      >
        <MBIconV2 name={checkboxIcon} color={Colors.v2.green} size={32} />
        {children}
      </ButtonView>
    </View>
  );
}
